<template>
  <loading-data-page-container :loading="loading" :loading-error="loadingError" :loading-error-message="loadingErrorMsg" class="schaden-detail-page">

    <v-container v-if="!loading && !loadingError" class="pa-0">

      <vertrags-header :vertragsnummer="vertragsInformation.vertragsnummer"
                       :kunden-name="vertragsInformation.kundenname"
                       page-name="Schadenübersicht">
        <v-btn v-if="!hideExcelDownload"
               slot="details-right"
               color="primary"
               @click="exportExcel">
          <v-icon>file_download</v-icon>
          EXCEL
        </v-btn>
      </vertrags-header>

      <table-container hide-details-search
                       no-excel-download>

        <vertrags-schaeden-table :schaeden="formattedSchaeden"
                                 :search="search" />

      </table-container>
      <div v-if="this.$route.params['backTo']"
           class="back-btn">
        <v-btn color="primary white--text"
               @click="goBack">Zurück
        </v-btn>
      </div>

    </v-container>

  </loading-data-page-container>
</template>
<script>
import httpService from '@/helper/httpService';
import TableContainer from "@/components/kundenverwaltung/TableContainer";
import VertragsSchaedenTable from "@/components/kundenverwaltung/VertragsSchaedenTable";
import TableDataMixin from '@/pages/kundenverwaltung/TableDataMixin';
import ExcelMixin from '@/pages/kundenverwaltung/ExcelMixin';
import dummyData from "@/store/dummyData/schaedenDummyData";
import VertragsHeader from "@/components/kundenverwaltung/VertragsHeader";
import LoadingDataPageContainer from "@/components/kundenverwaltung/LoadingDataPageContainer";
import { CONNECTION_ERROR_MESSAGE } from "@/helper/httpService";
import {RIGHTS} from "@/store/user";

export default {
  name: "SchadenDetailPage",
  components: { LoadingDataPageContainer, VertragsHeader, TableContainer, VertragsSchaedenTable },
  mixins: [ExcelMixin, TableDataMixin],
  data() {
    return {
      loading: true,
      loadingError: false,
      loadingErrorMsg: '',
      vertrag: null,
      schaeden: null,
      formattedSchaeden: [],
      search: ''
    };
  },
  computed: {
    vertragsInformation() {
      const info = {
        vertragsnummer: this.$route.params.vertragsnummer,
        kundenname: ''
      };
      if (this.vertrag) {
        info.vertragsnummer = this.vertrag.LangeVertragsnummer;
        info.kundenname = `${this.vertrag.Vorname} ${this.vertrag.Name}`;
      }
      return info;
    },
    hideExcelDownload () {
      return !this.$store.getters.checkAuthorization(RIGHTS.EXCEL);
    }
  },
  created() {
    Promise.all([
        httpService.getVertrag(this.$route.params.vertragsnummer, this.$route.params.vmnr),
        httpService.getSchaedenForVertrag(this.$route.params.vertragsnummer, this.$route.params.vmnr)
      ])
      .then(res => {
        let [vertrag, schaeden] = res;
        this.vertrag = vertrag;
        this.schaeden = schaeden;
        this.formattedSchaeden = schaeden.map(this.formatSchaden);
        this.loading = false;
      })
      .catch(err => {
        console.log(`GET SCHADENDETAILS failed with ${err.status}: ${err.message}`);
        //TODO delete dummy data for production
        if (this.$store.state.env.environment === 'development') {
          this.vertrag = dummyData.filter(s => s.contract.Vertragsnummer === this.$route.params.vertragsnummer)[0].contract;
          this.schaeden = dummyData.filter(s => s.contract.Vertragsnummer === this.$route.params.vertragsnummer)
            .map(s => {
              return { ...s.damage };
            });
          this.formattedSchaeden = this.schaeden.map(this.formatSchaden);
          this.loading = false;
        } else {
          this.loadingErrorMsg = err.status < 500 ? 'Keine Schäden gefunden' : CONNECTION_ERROR_MESSAGE;
          this.loadingError = true;
          this.loading = false;
        }
      });
  },
  methods: {
    formatSchaden(schaden) {
      return {
        Schadennummer: schaden.Schadennummer,
        Deckungszusage: schaden.Deckungszusage,
        Kosten: schaden.Kosten,
        erledigt: schaden.erledigt,
        Meldedatum: schaden.Meldedatum,
        MeldedatumSortable: this.$helpers.dateToTime(schaden.Meldedatum),
        VertragsTyp: schaden.VertragsTyp,
        Ereignisdatum: schaden.Ereignisdatum,
        EreignisdatumSortable: this.$helpers.dateToTime(schaden.Ereignisdatum)
      };
    },
    goBack: function () {
      window.history.back();
    },
    exportExcel() {
      this.generateExcel(this.schaeden.map(this.formatSchadenZumVertragDataForExcel), this.columnFormatSchadenZumVertragDataForExcel(), "Schaeden-Vertr-Nr-" + this.vertrag.Vertragsnummer);
    }
  }
};
</script>

<style>

.schaden-detail-page .v-input:not(.v-input--selection-controls) {
  max-width: 344px;
}

</style>
